class BeamDrawingComponent extends HTMLElement {
  connectedCallback() {
    this.innerHTML = String.raw`
      <div class="row mt-3" style="max-width: 900px;">
        <div class="col-12">
          <div id="drawing-panel" class="card card-default">
            <div class="card-body">
              <span class="float-start">
                <div id="beam-rotation-button-group" class="btn-group btn-group-sm hidden-print d-none">
                  <button type="button" id="beam-rotation-0-degrees-button" class="btn btn-primary"
                    onclick="rotateBeam0Degrees();">0&deg;</button>
                  <button type="button" id="beam-rotation-90-degrees-button" class="btn btn-default"
                    onclick="rotateBeam90Degrees();">90&deg;</button>
                </div>
              </span>
              <div id="canvas-pane"></div>
              <div class="float-start">
                <button id="design-this-beam-button" type="button"
                  class="btn btn-success btn-lg button-shadow hidden-print" onclick="doBeamFlexureDesign();">
                  <span id="calculate-wait-spinner" class="hidden"><i class="fa fa-spinner fa-spin"></i></span>
                  <span id="design-this-beam-text"> Calculate</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      `
  }
}

customElements.define('beam-drawing', BeamDrawingComponent);